import { theme } from "../../../foundations/theme.es.js";
import { styled } from "@mui/material";
import { BorderStyle } from "../../../foundations/border-style.es.js";
import { BorderRadius } from "../../../foundations/border-radius.es.js";
const BlockNoticeContainer = styled("div")({
  borderWidth: 1,
  borderStyle: BorderStyle.solid,
  borderRadius: BorderRadius.paper,
  overflow: "hidden",
  "&.primary": {
    borderColor: theme.palette.primary.main
  },
  "&.warning": {
    borderColor: theme.palette.warning.main
  }
});
export {
  BlockNoticeContainer
};
//# sourceMappingURL=block-notice-container.es.js.map
